import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  id: "my-login"
};
const _hoisted_2 = {
  class: "Overlay"
};
const _hoisted_3 = {
  class: "Modal"
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "justify-content": "flex-end"
  }
};
const _hoisted_5 = {
  class: "login-container"
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "cursor": "pointer",
    "margin-bottom": "10px"
  }
};
const _hoisted_7 = {
  class: "login-options"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.showDialog ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: "https://daimane.com/free/static/img/1725265287895.png",
    style: {
      "cursor": "pointer",
      "width": "25px"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closeDialog && $options.closeDialog(...args))
  })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("h3", {
    style: {
      "margin-right": "20px"
    },
    class: _normalizeClass($data.model.currentMenu == 1 ? 'current-menu' : 'not-current-menu'),
    onClick: _cache[1] || (_cache[1] = $event => $data.model.currentMenu = 1)
  }, "登录", 2), _createElementVNode("h3", {
    class: _normalizeClass($data.model.currentMenu == 2 ? 'current-menu' : 'not-current-menu'),
    onClick: _cache[2] || (_cache[2] = $event => $data.model.currentMenu = 2)
  }, "注册", 2)]), _createElementVNode("form", null, [_withDirectives(_createElementVNode("input", {
    type: "email",
    placeholder: "账户名",
    style: {
      "margin-bottom": "40px"
    },
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.model.user_name = $event)
  }, null, 512), [[_vModelText, $data.model.user_name]]), _withDirectives(_createElementVNode("input", {
    type: "password",
    placeholder: "密码",
    style: {
      "margin-bottom": "40px"
    },
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.model.password = $event)
  }, null, 512), [[_vModelText, $data.model.password]]), _createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
    type: "button",
    style: {
      "font-size": "15px"
    },
    onClick: _cache[5] || (_cache[5] = (...args) => $options.doSubmit && $options.doSubmit(...args))
  }, _toDisplayString($data.model.currentMenu == 1 ? '立即登录' : '立即注册'), 1)])])])])])])) : _createCommentVNode("", true);
}